goog.provide('yext.location.GoogleAttributeGroup');
goog.provide('yext.location.GoogleAttribute');

goog.require('yext');
goog.require('yext.location.Select');
goog.require('yext.location.helpers');

/**
 * Module for adding and updating Google My By Business location attributes.
 * NOTE(mattjs) This is for a single attribute group
 *
 * @author MattJS (matt@yext.com)
 * @constructor
 * @param {!jQuery} $ctx The field element context
 */
yext.location.GoogleAttributeGroup = function($ctx) {
  this.$ctx = $ctx;
  this.$fieldValue = this.$ctx.find('.js-field-value-json');

  this.id = $ctx.data('id');
  this.timestamp = $ctx.data('timestamp');
  this.attributes = {};

  this.bind();
  this.setFieldValueJSON();
};

/**
 * Construct GoogleAttribute classes for each attribute
 */
yext.location.GoogleAttributeGroup.prototype.bind = function() {
  var self = this;
  this.$ctx.find('.js-attribute').each(function() {
    self.newAttribute($(this));
  });
};

/**
 * @param {!jQuery} $attribute
 * @return {GoogleAttribute}
 */
yext.location.GoogleAttributeGroup.prototype.newAttribute = function($attribute) {
  var self = this;
  var attribute = new yext.location.GoogleAttribute($attribute);
  $(attribute.select).on('updated', function() {
    self.message('updated');
    self.setFieldValueJSON();
  });
  this.attributes[attribute.select.getName()] = attribute;
  return attribute;
};

/**
 * @param {string} message The message to be broadcast with the group instance as context
 */
yext.location.GoogleAttributeGroup.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * Resets the field to its stored state
 */
yext.location.GoogleAttributeGroup.prototype.reset = function() {
  for (var id in this.attributes) {
    this.attributes[id].select.reset();
  }
};

/**
 * Sets a hidden input field a JSON string that can be deserialized to an AttributeGroup in
 * GoogleAttributesView.java
 */
yext.location.GoogleAttributeGroup.prototype.setFieldValueJSON = function() {
  var data = [];

  for (var id in this.attributes) {
    data.push(this.attributes[id].getData());
  }

  var val = yext.JSON.stringify({
    'attributes': data,
    'id': this.id,
    'timestamp': this.timestamp,
  });

  this.$fieldValue.val(val);
};

/**
 * Get the display value for the field
 *
 * @param {string} HTML string of display value
 */
yext.location.GoogleAttributeGroup.prototype.getDisplayValue = function() {
  var sorted = [];
  var values = [];

  for (var id in this.attributes) {
    sorted.push(this.attributes[id]);
  }
  sorted.sort(function(a, b) {
    if (a.label < b.label) {
      return -1;
    }
    if (a.label > b.label) {
      return 1;
    }
    return 0;
  });

  for (var i = 0; i < sorted.length; i++) {
    var attribute = sorted[i];
    if (attribute.select.getValue() !== '') {
      values.push('<td>' + attribute.label + '</td><td>' + attribute.select.getLabel() + '</td>');
    } else if (attribute.select.data.indeterminate) {
      values.push('<td>' + attribute.label + '</td><td>' + yext.location.helpers.variousContentMessage() + '</td>');
    }
  }
  if (values.length > 0) {
    return '<table class="google-attributes-view"><tr>' + values.join('</tr><tr>') + '</tr></table>';
  } else {
    return yext.location.helpers.emptyFieldMessage();
  }
};

/**
 * Set the fields data
 *
 * @param {!Object} field Field data
 */
yext.location.GoogleAttributeGroup.prototype.set = function(field) {
  var attributes;
  for (var i = 0; i < field.attributeGroups.length; i++) {
    if (field.attributeGroups[i].id === this.id) {
      var group = field.attributeGroups[i];
      attributes = group.attributes;
      this.timestamp = group.timestamp;
      break;
    }
  }
  for (var i = 0; i < attributes.length; i++) {
    this.attributes[attributes[i].id].select.set(attributes[i]);
  }
};

/**
 * Store the current value of all attributes
 */
yext.location.GoogleAttributeGroup.prototype.storeValue = function() {
  for (var id in this.attributes) {
    this.attributes[id].select.storeValue();
  }
};

/**
 * Remove the group from the DOM and clean up bindings
 */
yext.location.GoogleAttributeGroup.prototype.destroy = function() {
  $(this).off();
  this.$ctx.closest('tr').remove();
};

/**
 * @constructor
 * @param {!jQuery} $ctx The field element context
 */
yext.location.GoogleAttribute = function($ctx) {
  this.$ctx = $ctx;
  this.select = new yext.location.Select($ctx.find('.js-select-component, .js-attribute-options'));
  this.label = $ctx.find('.js-attribute-label').text();
};

/**
 * Get the data for this attribute, formatted for deserialization to AttributeGroup.Attribute in
 * GoogleAttributesView.java
 */
yext.location.GoogleAttribute.prototype.getData = function() {
  return {
    id: this.select.getName(),
    value: this.select.getValue(),
    indeterminate: this.select.data.indeterminate,
  };
};

/**
 * Remove the attribute from the DOM and clean up bindings
 */
yext.location.GoogleAttribute.prototype.destroy = function() {
  $(this.select).off();
  this.$ctx.remove();
};
